export default "__VITE_ASSET__BjDuPU2$__"